import React from 'react';
import { Modal } from 'react-bootstrap';
import WofButton from '../../WofButton';
import { BonusPuzzleModalType } from '../../../types';
import { bonusPuzzleIds } from '../../../analyticsTags';

const BonusPuzzleModal: React.FC<BonusPuzzleModalType> = ({
  title,
  description,
  btnCloseText,
  show,
  onClose,
  onHide,
}) => (
  <Modal
    show={show}
    onHide={onHide}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered>
    <Modal.Body>
      <h4 className="bonus-puzzle-modal-text">{title}</h4>
<div className="bonus-puzzle-modal-desc" dangerouslySetInnerHTML={{
    __html: description,
}}/>

    </Modal.Body>
    {btnCloseText && (
      <Modal.Footer>
        <WofButton
          id={bonusPuzzleIds.bonusPuzzleAttemptModalClose}
          onClick={onClose}>
          {btnCloseText}
        </WofButton>
      </Modal.Footer>
    )}
  </Modal>
);

export default BonusPuzzleModal;
